import { render } from "./freezeLoading.vue?vue&type=template&id=ea9d6522&scoped=true"
import script from "./freezeLoading.vue?vue&type=script&lang=js"
export * from "./freezeLoading.vue?vue&type=script&lang=js"

import "./freezeLoading.vue?vue&type=style&index=0&id=ea9d6522&scoped=true&lang=css"

import exportComponent from "/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea9d6522"]])

export default __exports__